<template>
    <div>
        <div>
            <a-button class="top_btn" type="primary" @click="()=>{  visibleForm = true; titleForm='询盘垃圾邮箱规则设置' }"  > 添加
            </a-button>

            <a-popconfirm
                    title="此操作将永久删除, 是否继续?"
                    ok-text="确定"
                    cancel-text="取消"
                    @confirm="confirm('')"
                    @cancel="()=>{}"
                    :disabled="!hasSelected"
            >
                <a-button   type="primary" :disabled="!hasSelected" :loading="loading"  >
                    删除
                </a-button>
            </a-popconfirm>
            <span style="margin-left: 8px">
        <template v-if="hasSelected">
          {{ `选中 ${selectedRowKeys.length} 项` }}
        </template>
      </span>
        </div>
        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="false" rowKey="id"
                 :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"  >
          <span slot="status" slot-scope="text, record">
         <a-switch   @click="onChange(record)"
                   :checked="text==1?true:false" :disabled="!$_has('btn_status')"/>
      </span>
            <span slot="action" slot-scope="text, record">
        <a @click="(record)=>{visibleForm = true; titleForm='询盘垃圾邮箱规则设置'; editId=text.id ; }"  >编辑 <a-divider type="vertical"/></a>
          <a-popconfirm
                  title="此操作将永久删除, 是否继续?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="confirm([record.id])"
                  @cancel="()=>{}"
          >
   <a  >删除</a>
  </a-popconfirm>
      </span>
        </a-table>
        <NewForm :visible="visibleForm" :title="titleForm" :editId="editId"
                  @changVisible=" () => { this.visibleForm = false;this.editId='';  this.getList()}  "/>

    </div>

</template>

<script>
    import API from "./api";
    import NewForm from "./components/newForm"
    import {changStatus, removeById,orderList} from "../../../utils/utils"
    const columns = [
        {
            title: "询盘字段",
            dataIndex: "inquiry_field",
            ellipsis: true,
            key: "inquiry_field"
        },
      {
        title: "过滤内容",
        dataIndex: "content",
        ellipsis: true,
        key: "content"
      },
      {
        title: "包含次数",
        dataIndex: "times",
        ellipsis: true,
        key: "times"
      },
        {
            title: "操作",
            key: "action",
            width: "150px",
            scopedSlots: {customRender: "action"}
        }
    ];
    export default {
        name: 'index',
        data() {
            return {
                selectedRowKeys: [], // Check here to configure the default column
                visibleForm: false,
                titleForm: "",
                loading: true,
                editId: null,
                jurisdictionId: null,
                visibleJurisdiction: false,
                data: [],
                columns,
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/Set/InquiryGarbage"; //设置左侧导航2-2 active
        },
        components: {NewForm},
        computed: {
            hasSelected() {
                return this.selectedRowKeys.length > 0;
            },
        },
        methods: {
            getList(page) {
                API.administrator.GET_AROLE(page||1).then(res => {
                    this.data = res.data.data
                    this.loading = false
                })
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
            onChange(row) {
                let Json = {id: row.id, status: row.status == 0 ? 1 : 0}
                changStatus(API.administrator.CHANG_STATUS, [Json]).then(res => {
                    if (res == true) {
                        this.getList()
                    }
                })
            },
            confirm(id) {
                if(id==''){
                    id=this.selectedRowKeys
                }
                removeById(API.administrator.DELE,id).then(res => {
                    if (res == true) {
                        this.getList()
                        this.selectedRowKeys=[]
                    }
                })
            },
        },
        mounted() {
            this.getList()
        }

    }
</script>
